/**
 * 获取支付方式工具类
 *
 * @author terrfly
 * @site https://www.jeepay.vip
 * @date 2021/5/8 07:18
 */

import config from '@/config'

const getWayByForceWayCode = function (forceWayCode) {
    const normalized = (forceWayCode || '').toUpperCase();
    if (normalized === 'WX_JSAPI') {
        return config.payWay.WXPAY;
    }
    if (normalized === 'ALI_JSAPI') {
        return config.payWay.ALIPAY;
    }
    return null;
}

const getToPageRouteName = function () {
    const payWay = getPayWay();
    return  payWay? payWay.routeName : null
}

const getPayWay = function () {

    const userAgent = navigator.userAgent || '';
    const lowerUa = userAgent.toLowerCase();

    // 支持通过URL强制指定支付方式，便于排查UA识别问题
    const search = window.location.search || '';
    const hash = window.location.hash || '';
    const forceWayCode = (() => {
        const queryText = `${search}&${hash.includes('?') ? hash.split('?')[1] : ''}`;
        const matcher = queryText.match(/(?:^|[?&])wayCode=([^&#]+)/i);
        return matcher ? decodeURIComponent(matcher[1]) : '';
    })();

    const forceWay = getWayByForceWayCode(forceWayCode);
    if (forceWay) {
        return forceWay;
    }

    if(lowerUa.indexOf("micromessenger") >= 0){
        return config.payWay.WXPAY;
    }

    // 兼容旧版/新版支付宝UA
    if(lowerUa.indexOf("alipayclient") >= 0 || lowerUa.indexOf("aliapp(ap") >= 0){
        return config.payWay.ALIPAY;
    }

    return null;

}


export default { getToPageRouteName: getToPageRouteName,
    getPayWay: getPayWay

}
